// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var TypeUtils = require("./TypeUtils.bs.js");

function fromEnum(param) {
  if (typeof param === "number") {
    return param;
  } else {
    return 3;
  }
}

function toEnum(param) {
  switch (param) {
    case 0 :
        return /* NotLaunched */0;
    case 1 :
        return /* SupplyLaunchedOnly */1;
    case 2 :
        return /* Launched */2;
    default:
      return ;
  }
}

var include = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

function parseApiResponse(param) {
  if (typeof param === "string") {
    if (param === "SUPPLY_LAUNCHED_ONLY") {
      return /* SupplyLaunchedOnly */1;
    } else if (param === "LAUNCHED") {
      return /* Launched */2;
    } else {
      return /* NotLaunched */0;
    }
  }
  
}

function fromString(param) {
  switch (param) {
    case "Launched" :
        return /* Launched */2;
    case "Not Launched" :
        return /* NotLaunched */0;
    case "Supply Launched Only" :
        return /* SupplyLaunchedOnly */1;
    default:
      return ;
  }
}

function toString(str) {
  if (typeof str !== "number") {
    return str._0;
  }
  switch (str) {
    case /* NotLaunched */0 :
        return "Not Launched";
    case /* SupplyLaunchedOnly */1 :
        return "Supply Launched Only";
    case /* Launched */2 :
        return "Launched";
    
  }
}

function toApiString(str) {
  if (typeof str !== "number") {
    return str._0;
  }
  switch (str) {
    case /* NotLaunched */0 :
        return "NOT_LAUNCHED";
    case /* SupplyLaunchedOnly */1 :
        return "SUPPLY_LAUNCHED_ONLY";
    case /* Launched */2 :
        return "LAUNCHED";
    
  }
}

var fromEnum$1 = include.fromEnum;

var toEnum$1 = include.toEnum;

var eq = include.eq;

var compare = include.compare;

var Ord = include.Ord;

var compareWithConversion = include.compareWithConversion;

var compareReversed = include.compareReversed;

var OrdReversed = include.OrdReversed;

var compareAsInt = include.compareAsInt;

var min = include.min;

var max = include.max;

var lessThan = include.lessThan;

var lt = include.lt;

var lessThanOrEq = include.lessThanOrEq;

var lte = include.lte;

var greaterThan = include.greaterThan;

var gt = include.gt;

var greaterThanOrEq = include.greaterThanOrEq;

var gte = include.gte;

var clamp = include.clamp;

var between = include.between;

var OrdRingExtensions = include.OrdRingExtensions;

var OrdNamed = include.OrdNamed;

var OrdBy = include.OrdBy;

var $$Set = include.$$Set;

var SetWithNone = include.SetWithNone;

var $$Map = include.$$Map;

var list = include.list;

var array = include.array;

var set = include.set;

var setWithNone = include.setWithNone;

var cardinality = include.cardinality;

var top = include.top;

var bottom = include.bottom;

var succ = include.succ;

var pred = include.pred;

exports.fromEnum = fromEnum$1;
exports.toEnum = toEnum$1;
exports.eq = eq;
exports.compare = compare;
exports.Ord = Ord;
exports.compareWithConversion = compareWithConversion;
exports.compareReversed = compareReversed;
exports.OrdReversed = OrdReversed;
exports.compareAsInt = compareAsInt;
exports.min = min;
exports.max = max;
exports.lessThan = lessThan;
exports.lt = lt;
exports.lessThanOrEq = lessThanOrEq;
exports.lte = lte;
exports.greaterThan = greaterThan;
exports.gt = gt;
exports.greaterThanOrEq = greaterThanOrEq;
exports.gte = gte;
exports.clamp = clamp;
exports.between = between;
exports.OrdRingExtensions = OrdRingExtensions;
exports.OrdNamed = OrdNamed;
exports.OrdBy = OrdBy;
exports.$$Set = $$Set;
exports.SetWithNone = SetWithNone;
exports.$$Map = $$Map;
exports.list = list;
exports.array = array;
exports.set = set;
exports.setWithNone = setWithNone;
exports.cardinality = cardinality;
exports.top = top;
exports.bottom = bottom;
exports.succ = succ;
exports.pred = pred;
exports.parseApiResponse = parseApiResponse;
exports.fromString = fromString;
exports.toString = toString;
exports.toApiString = toApiString;
/* include Not a pure module */
